import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ConnectedRouter, push } from 'react-router-redux';
import { Route, Switch } from 'react-router';
import { firebaseConnect } from 'react-redux-firebase';

import { history } from './store';

import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import 'react-select/dist/react-select.css';
import './App.css';

import LandingPage from './routes/landing/landing';
import CompaniesPage from './routes/companies/companies';
import CompanyFormPage from './routes/companyform/companyform';
import JobsPage from './routes/jobs/jobs';
import JobFormPage from './routes/jobform/jobform';

import NotFoundPage from './routes/notfound/notfound';

class App extends React.Component {
  static propTypes = {
    auth: PropTypes.object,
    location: PropTypes.object
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.auth.isLoaded && !this.props.auth.isLoaded) {
      if (!nextProps.auth.isEmpty && this.props.location.pathname === '/') {
        this.props.dispatch(push('/companies'));
      } else if (nextProps.auth.isEmpty) {
        this.props.dispatch(push('/'));
      }
    }
  }

  render() {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path='/' component={LandingPage} />
          <Route path='/companies' component={CompaniesPage} />
          <Route path='/jobs' component={JobsPage} />
          <Route path='/companyform' component={CompanyFormPage} />
          <Route path='/jobform' component={JobFormPage} />
          <Route component={NotFoundPage} />
        </Switch>
      </ConnectedRouter>
    );
  }
}

const connectedApp = connect(
  (state, props) => ({
    auth: state.firebase.auth,
    location: state.router.location
  })
)(App);

const wrappedApp = firebaseConnect()(connectedApp);

export default wrappedApp;


// WEBPACK FOOTER //
// ./src/App.js